import React from "react";
import styled from "styled-components";

export interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
    value?: number;
    max?: number;
    color?: string;
    height?: string;
}

const ProgressBarContainer = styled.div<{ height?: string }>`
    width: 100%;
    height: ${({ height }) => height || "0.5rem"};
    background-color: ${({ theme }) => theme.palette.lightGrey};
    border-radius: 0.25rem;
    overflow: hidden;
`;

const ProgressBarFill = styled.div<{ value: number; max: number; color?: string }>`
    height: 100%;
    width: ${({ value, max }) => `${(value / max) * 100}%`};
    background-color: ${({ theme, color }) => color || theme.palette.primary};
    transition: width 0.3s ease;
`;

export const ProgressBar: React.FC<ProgressBarProps> = ({ value = 0, max = 100, color, height, style, ...props }) => {
    return (
        <ProgressBarContainer height={height} style={style} {...props}>
            <ProgressBarFill value={Math.min(Math.max(value, 0), max)} max={max} color={color} />
        </ProgressBarContainer>
    );
};

export default ProgressBar;


